class VideoCarousel extends SiteCarousel {
  constructor() {
    super();
    this.videos = null;
  }

  connectedCallback() {
    super.connectedCallback();

    this.initActiveVideo();
    this.setupVideoPlayback();
    this.setupChangeEvent();
  }

  initActiveVideo() {
    const videos = this.querySelectorAll("video");
    if (!videos.length) return;

    // On desktop (3 slides visible), play the middle video; otherwise play the first
    const initialIndex =
      window.innerWidth >= 1024 && videos.length >= 3 ? 1 : 0;
    const video = videos[initialIndex];
    if (video) {
      video.style.opacity = "1";
      video.play();
    }
  }

  setupVideoPlayback() {
    const videos = this.querySelectorAll("video");
    videos.forEach((video) => {
      video.addEventListener("mouseover", () => {
        this.pauseAllVideos();
        video.style.opacity = "1";
        video.play();
      });
    });
  }

  setupChangeEvent() {
    const videos = this.querySelectorAll("video");
    this.swiper.on("slideChange", () => {
      const match = videos[this.swiper.realIndex];
      if (match) {
        this.pauseAllVideos();
        match.style.opacity = "1";
        match.play();
      }
    });
  }

  pauseAllVideos() {
    const videos = this.querySelectorAll("video");
    videos.forEach((v) => {
      v.style.opacity = "";
      v.pause();
    });
  }
}

customElements.define("video-carousel", VideoCarousel);
